export default function WalletIcon({ color }: { color: string }) {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 5H7C5.89543 5 5 5.89543 5 7V17C5 18.1046 5.89543 19 7 19H16C17.1046 19 18 18.1046 18 17V16H15.1627C14.1284 16 13.167 15.4671 12.6187 14.59L11.9937 13.59C11.3857 12.6172 11.3857 11.3828 11.9937 10.41L12.6187 9.41C13.167 8.53286 14.1284 8 15.1627 8H18V7C18 5.89543 17.1046 5 16 5ZM19 8.06301V7C19 5.34315 17.6569 4 16 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H16C17.6569 20 19 18.6569 19 17V15.937C19.8626 15.715 20.5 14.9319 20.5 14V10C20.5 9.06808 19.8626 8.28503 19 8.06301ZM18.5 9H18H15.1627C14.4732 9 13.8322 9.35524 13.4667 9.94L12.8417 10.94C12.4364 11.5885 12.4364 12.4115 12.8417 13.06L13.4667 14.06C13.8322 14.6448 14.4732 15 15.1627 15H18H18.5C19.0523 15 19.5 14.5523 19.5 14V10C19.5 9.44771 19.0523 9 18.5 9ZM16 12C16 12.5523 15.5523 13 15 13C14.4477 13 14 12.5523 14 12C14 11.4477 14.4477 11 15 11C15.5523 11 16 11.4477 16 12Z"
          fill={color}
        />
      </svg>
    </>
  );
}
